/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _descriptor2, _ParamedicalCareEditionFormComponent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import RouterService from "@ember/routing/router-service";
import Transition from "@ember/routing/transition";
import { service } from "@ember/service";
import saveSendMessage from "core/components/chat/utils/save-send-message";
import CrudJournalEventBaseComponent from "core/components/forc/abstract/crud-journal-event-based-component";
import { Payload } from "core/components/forc/abstract/journal-event-based-component";
import JournalEventRetrievalStrategies from "core/components/forc/utils/journal-event-retrieval-strategies";
import ParamedicalCarePrescribedJournalEvent from "core/models/paramedical-care-prescribed-journal-event";
import AnalyticsService from "core/services/analytics";
import { sortBy } from "core/utils/sort";
let ParamedicalCareEditionFormComponent = (_class = (_ParamedicalCareEditionFormComponent = class ParamedicalCareEditionFormComponent extends CrudJournalEventBaseComponent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "router", _descriptor, this);
    _initializerDefineProperty(this, "analytics", _descriptor2, this);
    _defineProperty(this, "retrieveJournalEvent", JournalEventRetrievalStrategies.sourceJournalEvent);
    _defineProperty(this, "afterCompleted", () => this.router.transitionTo("medics-web.protected.patients.patient.dashboard"));
  }
  async save() {
    const model = await super.save();
    if (this.patient.authorizesAppUsage) {
      await saveSendMessage(model, {
        store: this.store,
        patient: this.args.patient,
        analytics: this.analytics
      });
      await this.store.createRecord("patient-chat-message-sent-journal-event", {
        occurredAt: new Date(),
        triggeringJournalEvent: model,
        patient: model.patient,
        body: "Nouvelle ordonnance reçue"
      }).save();
    }
    await this.draft.onDidSave();
    await this._openPrescriptionInNewTab();
  }
  async _openPrescriptionInNewTab() {
    // The last JE created of the given type should be the JE saved in the form.
    const journalEvent = this.store.peekAll("paramedical-care-prescribed-journal-event")
    // @ts-expect-error the @types/ember-data types are wrong.
    .toSorted(sortBy("occurredAt", "desc")).at(-1);

    // Open the PDF prescription in a new tab
    if (journalEvent) {
      this.router.transitionTo("medics-web.protected.patients.patient.prescriptions.paramedical-care-display", journalEvent.patient.id, journalEvent.id);
    } else {
      throw new Error("Impossible to open the PDF prescription because there is no JournalEvent found corresponding to the type : paramedical-care-prescribed-journal-event");
    }
  }
}, _defineProperty(_ParamedicalCareEditionFormComponent, "fullComponentId", "prescription/paramedical-care-edition-form"), _defineProperty(_ParamedicalCareEditionFormComponent, "forcDisplayName", "Prescription de soins paramédicaux"), _defineProperty(_ParamedicalCareEditionFormComponent, "journalEventClass", ParamedicalCarePrescribedJournalEvent), _ParamedicalCareEditionFormComponent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "analytics", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { ParamedicalCareEditionFormComponent as default };